import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import {
  Leaderboard,
  Rankboard,
  UpdateRatings,
  deletegames,
  endgame,
  gameCreate,
  gamejoingame,
  myRanking,
} from '../const';
import { io } from 'socket.io-client';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class PlayBoardService {
  private socket: any;

  constructor(private http: HttpClient, private router: Router) {}

  createData(data: any): Observable<any> {
    return this.http.post<any>(`${gameCreate}`, data);
  }

  joingameData(data: any): Observable<any> {
    return this.http.post<any>(`${gamejoingame}`, data);
  }

  endgameData(data: any): Observable<any> {
    return this.http.post<any>(`${endgame}`, data);
  }

  deleteGameData(id:any) {
    return this.http.post<any>(`${deletegames}`,id)
  }

  leaderBoardData() {
    return this.http.get<any>(`${Leaderboard}`);
  }

  newRatingData(id: any) {
    return this.http.get<any>(`${UpdateRatings}?gameId=${id}`);
  }

  rankBoardData(pageNumber: number, mode: string) {
    return this.http.get<any>(
      `${Rankboard}?page=${pageNumber}&gameMode=${mode}`
    );
  }

  myrankingData(mode: string) {
    return this.http.get<any>(`${myRanking}?gameMode=${mode}`);
  }
}
